export default __webpack_public_path__ + "static/media/gallery_08.eacf5b44.jpg";